module.exports = __webpack_public_path__ + "static/media/The Ballad of Orpheus.b7c294de.jpg";